import { ImportExportType } from "./importExport";
import { MenuConfig } from "./menu";
import { ModalConfig, ModalWithParams } from "./modal";

export enum EditorAction {
    SET_DATA = "[EditorAction] SET_DATA",
    SET_EXPORT_TYPE = "[EditorAction] SET_EXPORT_TYPE",
    SET_IMPORT_TYPE = "[EditorAction] SET_IMPORT_TYPE",
    SET_SEARCH_FILTER_KEY = "[EditorAction] SET_SEARCH_FILTER_KEY",
    SET_MODAL_CONFIG = "[EditorAction] SET_MODAL_CONFIG",
    SET_MENU_CONFIG = "[EditorAction] SET_MENU_CONFIG",
    TOGGLE_MODAL = "[EditorAction] TOGGLE_MODAL",
}

interface SetData {
    type: EditorAction.SET_DATA;
    data: Record<string, any>[];
    indexer: string;
}

interface SetExportType {
    type: EditorAction.SET_EXPORT_TYPE;
    exportType: ImportExportType;
}

interface SetImportType {
    type: EditorAction.SET_IMPORT_TYPE;
    importType: ImportExportType;
}

interface SetSearchFilterKey {
    type: EditorAction.SET_SEARCH_FILTER_KEY;
    searchFilterKey: string;
}

interface SetModalConfig {
    type: EditorAction.SET_MODAL_CONFIG;
    modalConfig: ModalConfig;
}

interface SetMenuConfig {
    type: EditorAction.SET_MENU_CONFIG;
    menuConfig: MenuConfig;
}

interface ToggleModal {
    type: EditorAction.TOGGLE_MODAL;
    modal?: ModalWithParams;
}

export type EditorActionTypes =
    | SetData
    | SetExportType
    | SetImportType
    | SetSearchFilterKey
    | SetModalConfig
    | SetMenuConfig
    | ToggleModal;
